import { render, staticRenderFns } from "./PrivadosPage.vue?vue&type=template&id=4fe07e12"
import script from "./PrivadosPage.vue?vue&type=script&lang=js"
export * from "./PrivadosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports